import MainForm from "../forms/mainForm";
import {currentHolidayLong, isHolidayFocus} from "../../models/variableCopywriting";


export default function SecondHero(props) {

    return (
        <main>
            <section className="">
                <section className="home-hero alignfull bg-[url('https://images.pexels.com/photos/7681196/pexels-photo-7681196.jpeg')] bg-no-repeat bg-cover bg-center h-screen w-full"
                         style={{
                             // "background": "url(https://images.pexels.com/photos/5711944/pexels-photo-5711944.jpeg) ",
                             "backgroundSize": "cover"
                         }}
                >
                    <div className="container" style={{display: 'flex', justifyContent: 'left'}}>
                        <figure className="">
                            <img decoding="async"
                                 src="https://images.pexels.com/photos/5711944/pexels-photo-5711944.jpeg"
                                 alt="Image of woman leader"/>
                        </figure>
                        <div className="form">

                            <div>
                                <div>
                                    <div>
                                        <h3>
                                            <div className="custom-font mb-12 justify-center items-center">
                                                {
                                                    isHolidayFocus ?
                                                        <span>{currentHolidayLong} RUSH</span> :
                                                        <strong>The only team you need for seo.</strong>
                                                }
                                            </div>
                                        </h3>
                                    </div>
                                    <div>
                                        <div className="custom-font font-thin text-white">
                                            {isHolidayFocus
                                                ? `Now’s the time to boost your visibility before the ${currentHolidayLong} crowds hit. Our Shopify SEO experts help you rise to the top, just in time for ${currentHolidayLong}.`
                                                : "Now’s the time to boost your visibility. Our Shopify SEO experts help you rise to the top of search results and grow your organic revenue."
                                            }
                                        </div>


                                        <MainForm formType={"proposal_request_secondary_hero"} />

                                    </div>

                                </div>

                            </div>
                        </div>
                    </div>
                </section>
            </section>


        </main>
    )
}